export default __webpack_public_path__ + "static/media/cat4.44ba32de.png";